import { Card, CardBody, Skeleton } from '@heroui/react';
import { Container } from '@school-manage/ui/Container/Container';
import { HeaderBar } from '@school-manage/ui/HeaderBar/HeaderBar';
import { useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { NftTopSection } from '../NftTopSection';

export function NftDetailSkeleton() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <>
      <HeaderBar
        backBtnHandler={() => navigate({ to: '/profile' })}
        hasBackBtn
        title={t('achievementDetail')}
      />
      <Container hasNavigationGap={false}>
        <NftTopSection />
        <div>
          <Skeleton className="mb-2 h-4 w-1/3 rounded-lg" />
          <Card shadow="none">
            <CardBody className="flex gap-y-2" style={{ minHeight: '50dvh' }}>
              {Array.from(Array(2).keys()).map((i) => (
                <Card key={i} shadow="sm">
                  <CardBody>
                    <Skeleton className="mb-2 h-4 w-4/5 rounded-lg" />
                    <Skeleton className="h-4 w-full rounded-lg" />
                  </CardBody>
                </Card>
              ))}
            </CardBody>
          </Card>
        </div>
      </Container>
    </>
  );
}
